import {
  AUTH_CONFIG_TOKEN,
  CORE_SEED_CONFIG_TOKEN,
  USER_ACCOUNT_CONFIG_TOKEN,
  USER_MANAGER_CONFIG_TOKEN,
} from '@aionzdev/modules';
import { FormCustomInputTypes } from '@aionzdev/design-system';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { environment } from '../../../environments/environment';

export function provideModulesConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CORE_SEED_CONFIG_TOKEN,
      useValue: {
        tenantId: 'ebarn-cot.ai',
        tenantName: 'eBarn Cot.AI',
        logo: 'assets/logo-horizontal.svg',
        apiUrl: environment.apiUrl,
        websocketUrl: environment.websocketUrl,
        project: 'cxm',
        modules: []
      },
    },
    {
      provide: AUTH_CONFIG_TOKEN,
      useValue: {
        usernameType: 'email',
        successUrl: ['/', 'main'],
        enableWebAuthn: true,
        enableFirstAccess: false,
        enableSign: false,
      },
    },
    {
      provide: USER_MANAGER_CONFIG_TOKEN,
      useValue: {
        showInviteButton: true,
      },
    },
    {
      provide: USER_ACCOUNT_CONFIG_TOKEN,
      useValue: {
        cpfRequired: false,
        emailRequired: false,
        userAttributes: [{
          key: 'bio',
          inputType: FormCustomInputTypes.TEXTAREA,
          input: {
            label: 'Biografia',
            placeholder: 'Escreva uma breve biografia',
            validations: {},
          },
        }],
        showManageAccount: false,
      },
    },
  ]);
}
